import type { BouncedEmailEntry, ResendEntry, ResendResult } from "@/interfaces/bouncedEmails";
import { apiClient } from "@/lib/apiClient";

export async function fetchBouncedEmails(campaignId: string): Promise<BouncedEmailEntry[]> {
  const { data } = await apiClient.get<BouncedEmailEntry[]>(
    `/campaigns/${campaignId}/bounced-emails`,
  );
  return data;
}

/** Rejects when no entry went out; per-entry failures of a partial send come back in `errors`. */
export async function resendBouncedEmails(
  campaignId: string,
  entries: ResendEntry[],
): Promise<ResendResult> {
  const { data } = await apiClient.post<ResendResult>(
    `/campaigns/${campaignId}/bounced-emails/resend`,
    { entries },
  );
  return data;
}
